// 3rd party
import { NgModule } from '@angular/core';

// pipes
import { FormatPipe } from 'app/shared/pipes/format.pipe';

@NgModule({
  exports: [
    FormatPipe
  ],
  declarations: [
    FormatPipe
  ]
})
export class PipesModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/pipes.module.ts